import { Outlet } from 'react-router-dom'
import { AuthModal } from '@/components/auth/AuthModal'
import { DepositModal } from '@/components/deposit'
import { SearchModal } from '@/components/search'
import { useGetCurrenciesQuery } from '@/store/api/paymentApi'
import { Header } from './header/Header'
import { Sidebar } from './sidebar/Sidebar'

export function Layout() {
	useGetCurrenciesQuery()

	return (
		<div className='min-h-screen text-foreground lg:flex lg:gap-4 lg:p-4'>
			<Sidebar />
			<div className='flex min-w-0 flex-1 flex-col'>
				<Header />
				<main className='flex min-h-0 min-w-0 flex-1 flex-col'>
					<Outlet />
				</main>
			</div>
			<AuthModal />
			<DepositModal />
			<SearchModal />
		</div>
	)
}
